import { RepresentativeData } from 'chaika-frontend-types/frontend-cms';

import { SimpleList } from '@store/models/SimpleList';

export class RepresentativeList extends SimpleList<RepresentativeData> {
    protected readonly identifiableFieldName: string = 'representativeId';
}
